import { Toolbar } from 'primereact/toolbar';
import PlanningNavBlock from '../components/NavBlocks/PlanningNavBlock';
import { useSideNavActive } from '../components/LayoutWrapper/SideNavLayoutContext';

const Planning = () => {
  const sideNavActive = useSideNavActive();

  return (
    <div className="grid nc_content-frame nc_page-inner">
      {!sideNavActive && (
        <Toolbar role="section" className="col-10 col-offset-1 nc_page-header" center={<h1>Plan</h1>} />
      )}
      <div className="col-10 col-offset-1 flex flex-column align-items-center">
        <div className="nc_block">
          <PlanningNavBlock></PlanningNavBlock>
        </div>
      </div>
    </div>
  );
};

export default Planning;
